import { useNavigate } from 'react-router-dom'
import AgentForm from '@/components/Agents/AgentForm'
import { useWorkspaceStore } from '@/stores/workspaceStore'
import { agentService } from '@/api/services/agent.service'
import type { BaseAgentRequest } from '@/api/types/agent.type'

const AddAgent = () => {
  const { currentWorkspace } = useWorkspaceStore()
  const navigate = useNavigate()

  // 处理创建智能体
  const handleCreate = async (agentRequest: BaseAgentRequest) => {
    try {
      console.log('创建智能体', agentRequest)

      // 调用API创建智能体
      await agentService.saveAgent(agentRequest)

      // 创建成功后跳转到列表页面
      navigate('/agents/list')
    } catch (error) {
      console.error('创建智能体失败:', error)
      // TODO: 显示错误提示
    }
  }

  // 处理取消
  const handleCancel = () => {
    console.log('取消创建')
    navigate('/agents')
  }

  return (
    <AgentForm
      onSubmit={handleCreate}
      onCancel={handleCancel}
      submitButtonText="创建"
      cancelButtonText="取消"
      workspaceId={currentWorkspace?.id || ''}
    />
  )
}

export default AddAgent
